<template>
  <ul class="hospitalTag" :class="{ '-lg': lg }">
    <li v-for="(tag, i) in tags" :key="i">
      <span
        class="hospitalTag_inner"
        :class="{ '-disable': tag.disabled }"
        v-if="tag.label.length > 0"
      >
        {{ tag.label }}
      </span>
    </li>
  </ul>
</template>

<script lang="ts">
interface Tag {
  disabled: boolean
  label: string
}
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'HospitalTag',

  props: {
    tags: Array as PropType<Tag[]>,
    lg: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalTag {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-weight: 700;
  font-size: 1rem;
  @include mixins.media() {
    font-size: 1.2rem;
  }

  &.-lg {
    margin-top: 20px;
    font-size: 1.4rem;
  }

  &_inner {
    border: 1px solid var.$color-main;
    color: var.$color-main;
    font-weight: 900;
    margin-right: 4px;
    margin-bottom: 4px;
    padding: 1px 6px;
    border-radius: 3px;

    &.-disable {
      font-weight: 400;
      color: #c6c6c6;
      border-color: #c6c6c6;
      background-color: #fff;
    }

    // @TODO ハイライト処理
    &[data-highlight='true'] {
      background-color: #fffccb;
    }
  }
}
</style>
